





























import { Component, Prop, Vue } from 'vue-property-decorator';
import ProjectManagementCard from '@/components/organizationDashboard/projectManagement/ProjectManagementCard.vue';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import { AllProjectCostAggregationResults } from '@/repository/@types/Organization';

@Component({
  components: {
    ProjectManagementCard,
    OrganizationIcon,
  },
})
export default class ProjectManagementBase extends Vue {
  private model: boolean = false;
  private organizationAvatarSize: number = 32;
  private organizationAvatarColor: string = '#0aadff';

  @Prop({ required: true })
  private allProjectCostAggregations!: AllProjectCostAggregationResults;
}
